import React from "react";
import { useField } from "formik";

import SelectPais from "./SelectPais";

function FormikSelectPais(props) {
  const [field, meta] = useField({ name: "paisId", ...props });

  return <SelectPais {...field} {...meta} {...props} />;
}

export default FormikSelectPais;
